import React from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("mb:client-error", {
          detail: {
            message: "A apărut o eroare de afișare.",
            error: String(error?.message || error),
            stack: info?.componentStack || "",
          },
        }),
      );
    }
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("Page render error:", error, info);
    }
  }

  reset = () => {
    this.setState({ hasError: false });
    if (typeof this.props.onReset === "function") this.props.onReset();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[40vh] flex items-center justify-center px-4 py-16">
          <div className="max-w-lg w-full rounded-sm border border-slate-200 bg-white p-8 text-center shadow-sm">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-700">
              <AlertTriangle size={22} />
            </div>
            <h2 className="font-display text-2xl font-medium text-slate-900">A apărut o eroare</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Interfața a întâlnit o problemă temporară. Reîncarcă pagina sau revino puțin mai târziu.
            </p>
            <div className="mt-6 flex items-center justify-center gap-3">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-2 rounded-sm bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-slate-700"
              >
                <RefreshCw size={14} />
                Reîncarcă
              </button>
              <button
                type="button"
                onClick={this.reset}
                className="rounded-sm border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
              >
                Încearcă din nou
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
